module.exports = function() { throw new Error("define cannot be used indirect"); };



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-define.js
// module id = 139
// module chunks = 0 3 7 8 10 16 17 23 25 26 30 36 39 42 44 63 68 74 78 79 82 87 88 89 103 104 105 143 153